export default __webpack_public_path__ + "static/media/tres-logos-fn-azul-short2.0e1c23fd.svg";